import React, { useEffect, useState } from 'react';
import '../../../../assets/css/pages/wizard/wizard-6.css';
import classNames from 'classnames';
import sMain from '../../pages/OnboardingPage.module.scss';
import s from './FirstStepsCustomization.module.scss';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { useSelector, } from 'react-redux';
import PeopleIcon from '@material-ui/icons/People';
import { invalidEmails } from '../../../../helper/invalid-emails';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import CollectionsIcon from '@material-ui/icons/Collections';
import { KTWizard } from '../../../../../_metronic/_assets/js/components/wizard'
import { isPasswordValid } from '../../../../helper/password-checker';
import { isWebsiteUrlValid } from '../../../../helper/url-checker';

export default function FirstStepsCustomization({ setMerchantInfo, merchantInfo, loading, shopifyUserInfo }) {
    const [contentRef, setContentRef] = useState(null);
    const [wizardObj, setWizardObj] = useState(null);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [showRequired, setShowRequired] = useState(false);
    const [nextButtonText, setNextButtonText] = useState('Get Started');
    const [merchantSite, setMerchantSite] = useState(merchantInfo?.merchantSite || '');
    const [adminFullname, setAdminFullname] = useState(merchantInfo?.adminFullname || '');
    const [merchantEmail, setMerchantEmail] = useState(merchantInfo?.merchantEmail || '');
    const [adminPassword, setAdminPassword] = useState(merchantInfo?.adminPassword || '');
    const [merchantId, setMerchantId] = useState(merchantInfo?.merchantId || '');
    const { user } = useSelector(
        ({ auth }) => ({
            user: auth.user,
        }),
    );
    useEffect(() => {
        if (contentRef) {
            setWizardObj(new KTWizard('first-step-wizard', {
                startStep: 1,
            }));
        }
    }, [contentRef]);

    useEffect(() => {
        if (!shopifyUserInfo) {
            return;
        }
        setMerchantSite(shopifyUserInfo.domain)
        setAdminFullname(shopifyUserInfo.name)
        setMerchantEmail(shopifyUserInfo.email)
    }, [shopifyUserInfo])

    useEffect(() => {
        try {
            const newMerchantId = isWebsiteValid().hostname
            setMerchantId(user?.merchantId || newMerchantId)
        } catch (error) {
            return;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [merchantSite]);

    const isEmailValid = () => {
        const splitEmail = merchantEmail.split('@');
        if (splitEmail.length !== 2 || invalidEmails[splitEmail[1]]) {
            return;
        }
        const emailRegex = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;
        return emailRegex.test(merchantEmail);
    };

    const isWebsiteValid = () => {
        if (!merchantSite) { return };
        return isWebsiteUrlValid(merchantSite);
    };

    const nextButtonClicked = () => {
        const firstStep = wizardObj.isFirstStep();
        wizardObj.goNext();
        if (firstStep) {
            setNextButtonText('Next');
            return;
        }

        if (!acceptTerms ||
            !isPasswordValid(adminPassword) ||
            !isEmailValid() ||
            !isWebsiteValid() ||
            !adminFullname) {
            setShowRequired(true);
        } else {
            setMerchantInfo({
                merchantId,
                merchantSite,
                merchantEmail,
                adminPassword,
                adminFullname,
            })
        }
    }

    const welcomeBoxes = [
        {
            header: 'Group shopping',
            text: 'Transform your website into an immersive shopping experience',
            icon: ShoppingCartIcon,
            color: '#7D63BC',
            backgroundColor: '#f2eff8',
        },
        {
            header: 'Q&A',
            text: 'Let your community share their recommendation and advise each other',
            icon: PeopleIcon,
            color: '#ef7865',
            backgroundColor: '#fdf1f0',
        },
        {
            header: 'UGC',
            text: 'Deliver authentic and high-performing content at the point of sale',
            icon: CollectionsIcon,
            color: '#f8c870',
            backgroundColor: '#fef9f1',
        },
    ]

    const textInputs = [
        shopifyUserInfo ? null :
            {
                inputLabel: 'Your Store URL',
                placeholder: "Type your store url...",
                function: setMerchantSite,
                value: merchantSite,
                type: 'url',
                errorMessage: isWebsiteValid() ? '' : 'Website link should be like this: www.example.com'
            },
        {
            inputLabel: 'Your Full Name',
            placeholder: "John Smith",
            function: setAdminFullname,
            value: adminFullname,
            type: 'name',
            errorMessage: adminFullname.length ? '' : 'Full name should be like this: John Smith',
        },
        {
            inputLabel: 'Email',
            function: setMerchantEmail,
            placeholder: "hello@yourstore",
            value: merchantEmail,
            type: "email",
            errorMessage: isEmailValid() ? '' : 'Please insert a valid business email'
        },
        {
            inputLabel: 'Password',
            placeholder: "Password...",
            function: setAdminPassword,
            value: adminPassword,
            type: "password",
            errorMessage: isPasswordValid(adminPassword) ? '' : '',
        },
    ]

    return (
        <div ref={setContentRef} style={{ paddingTop: '105px' }} className="wizard wizard-6 d-flex flex-column flex-lg-row flex-column-fluid" id="first-step-wizard">
            <div className="wizard-content d-flex flex-column w-100"
            >
                <div className="d-flex flex-column-auto flex-column">
                    <div className="wizard-nav pb-lg-10 pb-3 d-flex flex-column align-items-center align-items-md-start">
                        <div className="wizard-steps d-flex flex-column flex-md-row">
                            <div className="wizard-step flex-grow-1 flex-basis-0" data-wizard-type="step">
                            </div>
                            <div className="wizard-step flex-grow-1 flex-basis-0" data-wizard-type="step">
                            </div>
                        </div>
                    </div>
                </div>
                <form id="kt_form" autoComplete="on" className={classNames(sMain.blackFont)}>
                    <div style={{ paddingBottom: '3.1rem' }} data-wizard-type="step-content">
                        <div className="text-center text-md-left" style={{ paddingBottom: '3.4rem' }}>
                            <div className={classNames([s.welcomeHeader, sMain.fontWeight600])}>Welcome to Squadded</div>
                            <span className={classNames(s.welcomeSubHeader)}>Your one stop Interactive social solution for your e-commerce</span>
                        </div>
                        <div className={classNames(s['boxes-container'])}>
                            {welcomeBoxes.map(box =>
                                <div key={box.header}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}>
                                    <div className="mr-lg-7 symbol"
                                    >
                                        <span style={{
                                            borderRadius: '16px',
                                            width: '64px', height: '64px',
                                            color: box.color,
                                            backgroundColor: box.backgroundColor
                                        }} className="symbol-label">
                                            {React.createElement(box.icon,
                                                { style: { fontSize: '2rem' } })}
                                        </span>
                                    </div>
                                    <div>
                                        <div className={classNames([s.welcomeSubHeader, sMain.fontWeight500])}>
                                            {box.header}
                                        </div>
                                        <div className={classNames(sMain.greyText, sMain.mediumTextSize)} style={{ fontFamily: 'Poppins' }}>
                                            {box.text}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div data-wizard-type="step-content">
                        <div className="text-center text-md-left" style={{ paddingBottom: '3.3rem' }}>
                            <div className={classNames([sMain.stepHeader, sMain.fontWeight600])}>Create your squadded account</div>
                        </div>
                        {textInputs.map((input) => {
                            return input ?
                                <div key={input.placeholder}>
                                    <div style={{ marginBottom: '0.3rem' }} className={classNames([sMain.mediumTextSize, sMain.fontWeight500])}>{input.inputLabel}</div>
                                    <input
                                        defaultValue={input.value}
                                        onChange={(e) => input.function(e.target.value)}
                                        type={input.type || ''}
                                        placeholder={input.placeholder}
                                        name={input.type}
                                        style={{ width: '616px' }}
                                        className="form-control form-control-solid h-auto p-6 border-0 rounded-lg font-size-h4"
                                        rows="5"></input>

                                    {input.type === 'password'
                                        ?
                                        <div style={{ marginTop: '0.3rem', color: ((showRequired || adminPassword.length) && !isPasswordValid(adminPassword)) && '#f6566a' }} className={classNames([sMain.smallTextSize, sMain.greyText])}>At least 8 characters, and must contain one symbol, letters and numbers</div>
                                        :
                                        <label style={{ marginBottom: '0' }} htmlFor={input.type} name={input.type} />
                                    }
                                    {showRequired
                                        ?
                                        <p className="text-danger">{input.errorMessage}</p>
                                        : null
                                    }
                                </div>
                                : null
                        }

                        )}
                        <div className="form-group" style={{ position: 'relative' }}>
                            <label className={classNames('checkbox', 'd-block', s.checkboxStyling, 'checkbox-dark')} style={{
                                position: 'absolute',
                                top: '-4px'
                            }}>
                                <input onChange={(e) => setAcceptTerms(e.target.checked)} type="checkbox" />
                                <span style={{ width: '24px', height: '24px' }}></span>
                            </label>
                            <div style={{ marginLeft: '3rem', marginTop: '3.8rem' }} className={classNames([sMain.smallTextSize, sMain.greyText])}>
                                By proceeding on this platform, you are agreeing to our&nbsp;
                                <a style={{
                                    fontWeight: '500',
                                    textDecoration: 'underline',
                                    color: 'black'
                                }} href='https://www.squadded.co/terms-policy' target='_blank' rel='noopener noreferrer'>
                                    terms and conditions
                                </a>
                            </div >
                            {showRequired && !acceptTerms
                                ?
                                <p className="mt-lg-2 text-danger">* Required</p>
                                : null
                            }
                        </div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <button onClick={nextButtonClicked} style={{ borderRadius: '8px', backgroundColor: 'black' }} type="button" className="btn btn-dark font-size-h6 pl-8 pr-4 py-4 my-3">
                            {nextButtonText}
                            {loading ?
                                <>
                                    <span style={{ marginLeft: '1.3rem' }} className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </>
                                :
                                <>
                                    <i><ArrowForwardOutlinedIcon style={{ marginLeft: '0.4rem' }} /></i>
                                </>
                            }
                        </button>
                    </div>
                </form>
            </div >
        </div >
    );
}
